import { httpRequest } from "@/utils/HttpRequest";
import { ITasteFields, ITasteDetial, ITasteInsert, ITasteUpdate } from "./tasteType";

class TasteService {
    async findByMeal(searchVo: ITasteFields) {
        const apiUrl = "/common/menu/findByMeal";
        return await httpRequest.post<ITasteDetial[]>(apiUrl, searchVo);
    }
    async statisByMenu(menuId: any) {
        const apiUrl = `/booking/statisByMenu/${menuId}`;
        return await httpRequest.get<any>(apiUrl);
    }
    async insert(searchVo: ITasteInsert) {
        const apiUrl = "/common/menu/insert";
        return await httpRequest.post<boolean>(apiUrl, searchVo);
    }
    async update(searchVo: ITasteUpdate) {
        const apiUrl = "/common/menu/update";
        return await httpRequest.post<boolean>(apiUrl, searchVo);
    }
}
export const tasteService = new TasteService();
